<template>

    <section id="main_slider" style="cursor:move;">
        <!-- Swiper -->
        <div class="swiper-container main_slider">
            <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="s in widget.images">
                    <a :href="s.split('?url=')[1]" target="_blank">
                        <img class="img-responsive" :src="s" alt="fashion show" width="100%">
                    </a>
                </div>
            </div>
            <!-- Add Pagination -->
            <div class="swiper-pagination"></div>
            <!-- Add Arrows -->
            <div class="swiper-button-next"></div>
            <div class="swiper-button-prev"></div>
        </div>

    </section>

</template>

<script>
export default {
    props: ['widget'],
    mounted: function() {
        var swiper = new Swiper('.main_slider', {
            spaceBetween: 30,
            centeredSlides: true,
            loop: true,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        });
    }
}
</script>

<style>
.swiper-button-next{
    /* background-image: none; */
    margin-top: 0px;
    top:0px;
    width: 150px;
    height: 100%;
}
.swiper-button-prev{
    /* background-image: none; */
    margin-top: 0px;
    top:0px;
    width: 150px;
    height: 100%;
}
@media screen and (max-width:576px){
    .swiper-button-next{
        background-image: none;
    }
    .swiper-button-prev{
        background-image: none;
    }
}
</style>



// WEBPACK FOOTER //
// ImageSliderWidget.vue?7ac34d1c